import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=42adc3ce&lang=css"
import "./App.vue?vue&type=style&index=1&id=42adc3ce&media=screen&lang=css"

const __exports__ = script;

export default __exports__